export default __webpack_public_path__ + "static/media/oakley fluted panel.aa9ac269.png";